import { gate } from 'hub-http/gates';
export const GATES = {
  LEGAL_CONSENT_LIB: gate('Meetings:LegalConsentLib')
};